import { Component, Input,OnInit,HostListener,ViewChild,ElementRef} from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';

@Component({
  selector: 'app-studentrankreport',
  templateUrl: './studentrankreport.component.html',
  styleUrls: ['./studentrankreport.component.css'],
  providers: [TestSeriesService]
})
export class StudentrankreportComponent implements OnInit {
  @Input() selectedPaperId;
  userData:any;
  testPaperId:any=0;
  topTen:any;
  isError = false;
  notfound = false;
  isPostLoad:any;
  msg = '';
  totalStudends:any;
  studendRank:any;
  topRanker:any;
  constructor(private http:Http,private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) {
   
    
    this.commonService.profile.subscribe((data:any)=>{
      if(data){
      this.userData=data; 
      }else{
        this.userData={};
      } 
    });

   }


  ngOnInit() {
    this.testPaperId = (this.selectedPaperId) ? this.selectedPaperId.value : 0;
     console.log(this.selectedPaperId.value);
     let filter = {};
    filter['testPaperId'] = this.testPaperId;
    filter['studentId'] = (this.userData.id)?this.userData.id:0;
    this.getPapersReportSummery(filter);
}


getPapersReportSummery(obj){
  this.testseriesservice.getStudentDetailedReport(obj).subscribe((data:any)=>{
    
       if(data.error==0){ 
         this.topTen= data.results.topTen;
         this.totalStudends =  data.results.totalStudentCount[0];
         this.studendRank = data.results.studendRank[0];
         this.notfound = false;
         this.isError = false;
         this.isPostLoad = false;

         //console.log('6666',this.studendRank,this.topTen,this.totalStudends);
     }else{
       if(data.message=="Failed to authenticate token."){
         sessionStorage.clear();
         localStorage.clear();
         this.router.navigate(['/']);
       }else{
        this.msg = data.message;
        this.isError = true;
       }
       this.notfound = true;
       this.isPostLoad = false;
       this.topTen= [];
       this.totalStudends = {};
       this.studendRank = {};
      
     }
   },(error : HttpErrorResponse)=>{    
     this.isPostLoad=false;  
     this.isError = true;
     this.msg="internal server error!";
   });   
}

getpercentile(yourRank,totalcount){
  let rr:any;
 rr = (yourRank*100)/totalcount;
  return (100 - parseFloat(rr));
}

getpercent(yourRank,totalmarks){
 return Number((yourRank*100)/totalmarks).toFixed(2);
}

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/studentrankreport/studentrankreport.component.ts